import React from 'react'

import logo from '../images/gordon_logo.svg'
import { FooterLogo, FooterRoot } from '../styles/components/FooterStyle'

const Footer = () => {
  return (
    <FooterRoot className="sticky-vertical">
      <FooterLogo src={logo} alt="Logo" />
    </FooterRoot>
  )
}

export default Footer
